import { useEffect, useState } from "react"
import ContainerLayout from "./containerlayout"
import Accordion from "../campusLife/accordion"
import { DecodeHtml } from "../../utils/decodeHtml"
import { PropTypes } from 'prop-types';

const ContactUs = ({ admission }) => {


    const header6 = admission?.header6
    const description6 = admission?.description6

    const [accordion, setAccordion] = useState([])

    useEffect(() => {
        setAccordion(
            admission?.accordions2?.items?.map(item => {
                item = item?.content?.properties
                return ({
                    question: item?.label,
                    answer: DecodeHtml({ html: item?.accordionContent?.markup }),
                    open: false
                }
                )
            })
        )
    }, [admission?.accordions2?.items])
    // const [accordion, setAccordion] = useState([
    //     {
    //         question: "Application & Offer Letter",
    //         answer:
    //             <OfferLetter />
    //         ,
    //         isOpen: true
    //     },
    //     {
    //         question: "Online Registration",
    //         answer:
    //             <OnlineRegistration />
    //         ,
    //         isOpen: false
    //     },
    //     {
    //         question: "Orientation",
    //         answer:
    //             <Orientation />
    //         ,
    //         isOpen: false
    //     },
    //     {
    //         question: "Class Schedule",
    //         answer:
    //             <ClassSchedule />
    //         ,
    //         isOpen: false
    //     },
    //     {
    //         question: "Virtual Learning",
    //         answer:
    //             <VirtualLearning />
    //         ,
    //         isOpen: false
    //     },
    //     {
    //         question: "Payment Matters, Letter of Consent (LOC), Letter of Guarantee (LOG) & Letter of Indemnity (LOI) Forms",
    //         answer:
    //             <Payment />
    //         ,
    //         isOpen: false
    //     },
    //     {
    //         question: "Accommodation",
    //         answer:
    //            <Accomodation/>
    //         ,
    //         isOpen: false
    //     },
    //     {
    //         question: "Tabung Amanah Zakat UNITEN",
    //         answer:
    //             <Zakat/>
    //         ,
    //         isOpen: false
    //     },

    // ])

    return (
        <ContainerLayout>
            <h1 className="w-auto   text-4xl font-bold  leading-snug">{header6}</h1>
            <p className=" text-justify text-slate-500">{description6}</p>
            <Accordion accordion={accordion} setAccordion={setAccordion} />

        </ContainerLayout>
    )
}
ContactUs.propTypes ={
    admission: PropTypes.object
}
export default ContactUs